import { render, staticRenderFns } from "./OrgSpinButton.vue?vue&type=template&id=73167454&scoped=true&"
import script from "./OrgSpinButton.vue?vue&type=script&lang=ts&"
export * from "./OrgSpinButton.vue?vue&type=script&lang=ts&"
import style0 from "./OrgSpinButton.vue?vue&type=style&index=0&id=73167454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73167454",
  null
  
)

export default component.exports